import { get } from "./api";

export const getNotificationsByDialogDefinitionId = async (dialogDefinitionId) => {
    return await get(`dialogDefinitions/${dialogDefinitionId}/notifications`);
}